{
  "states": {
    "loading": "Loading dashboard…"
  },
  "hero": {
    "title": "Parent Dashboard",
    "subtitle": "Track quiz progress and manage each child profile."
  },
  "childPicker": {
    "label": "Viewing",
    "placeholder": "Select…",
    "grade": "Grade {grade}",
    "addChild": "Add Child"
  },
  "quizProgress": {
    "title": "Quiz Progress",
    "subtitle": "Track each child profile activity and quiz performance",
    "emptySelect": "Select a child to see progress",
    "emptyTitle": "No quiz activity yet",
    "emptySubtitle": "Ask {name} to complete a quiz to populate this section.",
    "summary": "{questions} questions answered · {likes} liked",
    "accuracy": "Accuracy",
    "streak": "Day Streak",
    "cards": {
      "totalQuestions": "Total Questions",
      "liked": "Liked",
      "streak": "Day Streak",
      "daysActive": "Days Active"
    }
  },
  "activity": {
    "title": "30-Day Learning Activity",
    "activeDays": "{count} active days",
    "empty": "No activity data yet",
    "tooltip": {
      "questions": "{count} questions answered",
      "correct": "{count} correct",
      "rounds": "{count} quiz round",
      "none": "No activity"
    }
  },
  "topics": {
    "title": "Top Topics Explored",
    "legend": {
      "explored": "Explored",
      "liked": "Liked"
    },
    "showFewer": "Show fewer",
    "showMore": "+{count} more",
    "tooltip": {
      "explored": "{count} questions explored",
      "liked": "{count} liked"
    },
    "empty": "No topics explored yet"
  },
  "favorites": {
    "title": "{name}'s Favorite Questions"
  },
  "lastQuiz": {
    "label": "Last quiz:",
    "at": "at"
  },
  "heatmap": {
    "title": "When does {name} learn?",
    "axis": {
      "midnight": "12am",
      "morning": "6am",
      "noon": "12pm",
      "evening": "6pm"
    },
    "time": {
      "am": "am",
      "pm": "pm"
    },
    "tooltip": {
      "events": "{count} events",
      "label": "Activity",
      "time": "{hour}:00 {period}"
    },
    "footer": "Times shown in your local timezone · last 30 days"
  },
  "engagement": {
    "title": "How {name} engages",
    "cards": {
      "flipped": "Cards Flipped",
      "reads": "Full Reads",
      "liked": "Liked"
    },
    "flips": "{count} flips"
  },
  "history": {
    "title": "Quiz History",
    "columns": {
      "when": "When",
      "mode": "Mode",
      "category": "Category",
      "score": "Score",
      "result": "Result",
      "none": "—"
    },
    "status": {
      "done": "✓ Done",
      "out": "💔 Out",
      "unknown": "—"
    },
    "showFewer": "Show fewer",
    "showAll": "Show all {count} rounds"
  },
  "profiles": {
    "title": "Child Profiles",
    "empty": {
      "title": "No child profiles yet. Add one to get started!",
      "cta": "Add your first child"
    },
    "grade": "Grade {grade}",
    "readingLevel": "Reading Level",
    "actions": {
      "edit": "Edit",
      "resetPin": "Reset PIN",
      "delete": "Delete"
    }
  },
  "privacy": {
    "title": "Data & Privacy",
    "subtitle": "Manage device provisioning and account data actions.",
    "actions": {
      "creating": "Creating…",
      "createToken": "Create Provision Token",
      "download": "Download Data Archive"
    },
    "token": {
      "label": "Token",
      "expires": "Expires: {date}",
      "copy": "Copy",
      "open": "Open Link",
      "qrAlt": "Provision QR"
    }
  },
  "subscription": {
    "title": "Subscription",
    "renews": "Renews",
    "actions": {
      "opening": "Opening…",
      "manage": "Manage subscription",
      "upgrade": "Upgrade"
    },
    "free": "You are on the free experience."
  },
  "alerts": {
    "pinInvalid": "Please enter a valid 4-digit PIN",
    "pinReset": "PIN reset successfully!",
    "pinResetFailed": "Failed to reset PIN",
    "nicknameRequired": "Nickname is required",
    "nicknameLength": "Nickname must be between 2 and 20 characters",
    "childUpdated": "Child profile updated successfully!",
    "childUpdateFailed": "Failed to update child profile",
    "childDeleted": "Child profile deleted successfully",
    "childDeleteFailed": "Failed to delete child profile",
    "deviceTokenFailed": "Failed to create device token",
    "readingLevelFailed": "Failed to save reading level"
  },
  "billing": {
    "plans": {
      "free": "Free",
      "annual": "Family Annual",
      "monthly": "Family Monthly"
    }
  },
  "readingLevel": {
    "lexile": "Lexile {level}",
    "auto": "Auto -> Lexile {level}",
    "options": {
      "auto": "Auto (Grade {grade}, Lexile {level})",
      "lexile795": "Lexile 795 (Ages 7-9)",
      "lexile1260": "Lexile 1260 (Ages 10-12)",
      "lexile1479": "Lexile 1479 (Ages 13-15)"
    }
  },
  "modals": {
    "edit": {
      "title": "Edit {name}",
      "labels": {
        "nickname": "Nickname",
        "grade": "Grade"
      },
      "placeholders": {
        "nickname": "Enter nickname"
      },
      "preschool": "Preschool",
      "grade": "Grade {grade}",
      "actions": {
        "cancel": "Cancel",
        "save": "Save Changes"
      }
    },
    "pin": {
      "title": "Reset PIN for {name}",
      "subtitle": "Enter a new 4-digit PIN for {name}. They will use this to log in.",
      "placeholder": "Enter 4-digit PIN",
      "actions": {
        "cancel": "Cancel",
        "reset": "Reset PIN"
      }
    },
    "delete": {
      "title": "Delete {name}?",
      "subtitle": "This removes the child profile and cannot be undone.",
      "actions": {
        "cancel": "Cancel",
        "confirm": "Delete Profile"
      }
    }
  }
}
